import Vue from 'vue';
export const EventBus = new Vue();



//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/event-bus.js
// module id = d7U0
// module chunks = 0